// extracted by mini-css-extract-plugin
export default {"group":"styles_group__6EpyE","cell":"styles_cell__JZVRy","title":"styles_title__3-zCO","highlightLeft":"styles_highlightLeft__XlOvf"};